<template>
  <PanelV2
    type="w7"
    title="Grow your business with cashless payment acceptance!"
    @nextClick="next()"
  >
    <template v-slot:content-solt>
      <Digital digitalType="pos" @checkboxClick="checkboxClick" :digitalData="formData" />
    </template>
  </PanelV2>
</template>

<script>
  import PanelV2 from "../components/PanelV2";
  import Digital from "./common/Digital.vue";
  import API from "@/api";
  import { getUrlParam } from "../../plugins/utils";
  export default {
    name: 'CorporationC',
    pRouter: 'CorporationB',
    components: {
      PanelV2,
      Digital
    },
    data() {
      return {
        formData: null
      }
    },
    methods: {
      checkboxClick(val) {
        this.formData = val
      },
      next() {
        if(this.formData.every(val => val.chooseFlag == '2') && getUrlParam('isSelected') === 'false') {
            this.$confirm({
                tip: true,
                mesg: 'You may choose 1 or more products from the digital/physical store options.',
            })
          return
        }
        const data = this.formatCommitData({physicalPaymentList: this.formData})
        API.addBdoProcess({
            ...data
          }).then(res => {
            if(res.success) {
              this.toNext()
            }
          })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
